import { useState } from "react";
import { fetchApi } from "../api-utils/fetcher";

type Options = {
  onSuccess?(): void;
};

export default function useDeleteComment(
  _id: string,
  { onSuccess }: Options = {}
) {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteComment = async () => {
    setIsDeleting(true);
    try {
      await fetchApi("/api/comment", {
        method: "DELETE",
        data: {
          _id
        }
      });
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      // TODO Handle Errors!
      console.error(err);
    } finally {
      setIsDeleting(false);
    }
  };
  return {
    deleteComment,
    isDeleting
  };
}
